module.exports = __webpack_public_path__ + "img/Full Flavour Tobaccos.530ad03f.jpg";